import React from "react";
import {
    FormLayout,
    HeaderActions,
    Heading,
    Input,
    LoadingProgress,
    Panel,
    Text,
} from "@/ui";
import { Icon } from "@/components";
import useMeta from "../../base/hooks/useMeta";
import useForm from "../../base/hooks/form/useForm";
import useFormActions from "../../base/hooks/form/useFormActions";
import {
    MUTATION_UPDATE_BERBIX_APP,
    QUERY_LIST_STORE_APPS,
} from "../../apollo/module-operations/app";
import _ from "lodash";
import useValidator from "../../base/hooks/form/useValidator";
import styles from "./GeneralsForm.module.scss";

const SaveIcon = () => <Icon icon="save" />;

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const BerbixForm = ({ app }) => {
    const { user } = useMeta();
    const { inputs, setInputs, inputChange } = useForm();

    if (!_.get(inputs, "id", null)) {
        setInputs(app);
    }

    let options = {
        variables: {
            account_id: user.accountId,
            store_id: user.storeId,
            input: {
                ...inputs,
                id: inputs.id,
                secret_key: inputs.secret_key,
                template: inputs.template,
                type: "Berbix",
            },
        },
    };

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "id",
                method: "isEmpty",
                validWhen: false,
                message: "This app id is required.",
            },

            {
                field: "secret_key",
                method: "isEmpty",
                validWhen: false,
                message: "This secret key is required.",
            },

            {
                field: "template",
                method: "isEmpty",
                validWhen: false,
                message: "This template is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    const { createOrUpdate, loading } = useFormActions(
        "id",
        "Redirect",
        "",
        MUTATION_UPDATE_BERBIX_APP,
        [
            {
                query: QUERY_LIST_STORE_APPS,
                variables: {
                    account_id: user.accountId,
                    store_id: user.storeId,
                },
                skip: user.loading || !user.accountId || !user.storeId,
            },
        ],
        options,
        "",
        isValid,
        isSubmited,
        "primary",
    );

    return (
        <Panel
            className={styles.root}
            header={
                <div className={styles.headerBar}>
                    <div className={styles.headerText}>
                        <Heading level={4}>Berbix</Heading>
                        <Text tone="secondary" variant="body-sm">
                            Berbix Information
                        </Text>
                    </div>
                    <HeaderActions
                        actions={[
                            {
                                id: "update",
                                label: "Update",
                                icon: loading ? undefined : <SaveIcon />,
                                loading,
                                disabled: loading,
                                onClick: () => createOrUpdate(),
                            },
                        ]}
                        aria-label="Berbix actions"
                    />
                </div>
            }
            showHeaderDivider
        >
            {user.loading ? (
                <div className={styles.loading}>
                    <LoadingProgress
                        indeterminate
                        indicator="circular"
                        size="sm"
                        title="Loading"
                    />
                </div>
            ) : (
                <FormLayout>
                    <FormLayout.Section title="Information">
                        <FormLayout.Grid columns={2} maxWidth="twoThirds">
                            <Input
                                error={fieldError(validator, "secret_key")}
                                fullWidth
                                label="Secret Key"
                                name="secret_key"
                                onChange={inputChange}
                                value={inputs.secret_key || ""}
                            />
                            <div />
                            <Input
                                error={fieldError(validator, "template")}
                                fullWidth
                                label="Template"
                                name="template"
                                onChange={inputChange}
                                value={inputs.template || ""}
                            />
                        </FormLayout.Grid>
                    </FormLayout.Section>
                </FormLayout>
            )}
        </Panel>
    );
};

export default BerbixForm;
